module.exports = function() {
	return new Worker(__webpack_public_path__ + "f7ef074d2831e19fcdbd.grid.wrkr.js");
};